import React from "react";
import { Button, List } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useAppSelector } from "../store/hooks";
import { BrickSeries, selectSeriesList } from "../store/slices/bricksSlice";
import { selectSelectedBricks } from "../store/slices/configurationSlice";
import { StoneRow } from "./Menu/StoneRow";

interface Props {
  onSelect(b: BrickSeries): void;
  onBack(): void;
}
const BrickPicker: React.FC<Props> = ({ onSelect, onBack }) => {
  const seriesList = useAppSelector(selectSeriesList);
  const selectedBricks = useAppSelector(selectSelectedBricks);
  return (
    <div
      style={{ maxHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <div className="header">
        <Button onClick={onBack} type="primary" icon={<LeftOutlined />}>
          Terug
        </Button>
      </div>
      <List
        className=""
        itemLayout="horizontal"
        style={{ flex: 1, overflow: "auto" }}
      >
        {seriesList.map((b: BrickSeries) => (
          <StoneRow
            key={b._id}
            brick={b}
            onClick={() => onSelect(b)}
            selected={selectedBricks.hasOwnProperty(b._id)}
          />
        ))}
      </List>
    </div>
  );
};

export default BrickPicker;
